import { withInstall } from '@ll-plus/utils'

import Segmented from './src/segmented.vue'

export const LlSegmented = withInstall(Segmented)
export default LlSegmented
export * from './src/segmented'

declare module 'vue' {
  export interface GlobalComponents {
    LlSegmented: typeof Segmented
  }
}
